import { HStack, useTheme } from "native-base";
import React from "react";
import { Platform } from "react-native";
import Animated, { SharedValue, interpolateColor, useAnimatedStyle } from "react-native-reanimated";

import FormButton from "@/components/atoms/FormButton";
import { useAppSelector } from "@/hooks/application/store";

import HeaderAccountButton from "../HeaderAccountButton";
import HeaderAddressButton from "../HeaderAddressButton";
import HearderCartButton from "../HearderCartButton";

type AnimatedHeaderProps = {
  animatedValue: SharedValue<number>;
  onPressLogin: () => void;
};

const AnimatedHeader = ({ animatedValue, onPressLogin }: AnimatedHeaderProps) => {
  const { colors } = useTheme();

  const { logged } = useAppSelector((store) => store.auth);

  const style = useAnimatedStyle(() => {
    return {
      backgroundColor: interpolateColor(
        animatedValue.value,
        [0, 5],
        [colors.secondary[400], "white"]
      ),
      ...Platform.select({
        web: {
          boxShadow: `0px 2px 4px ${interpolateColor(
            animatedValue.value,
            [0, 5],
            ["transparent", "#00000040"]
          )}`,
        },
      }),
    };
  });

  return (
    <HStack position="sticky" top={0} zIndex={999}>
      <Animated.View
        style={[
          {
            width: "100%",
            backgroundColor: colors.secondary[400],
            alignItems: "center",
          },
          style,
        ]}>
        <HStack w="full" px="1/5" justifyContent="space-between" py={2}>
          <HeaderAddressButton shadow="4" p="2" px="4" borderRadius={10} />
          <HStack alignItems="center">
            <HearderCartButton />
            {logged ? (
              <HeaderAccountButton />
            ) : (
              <FormButton h="40px" px="8" ml="8" onPress={onPressLogin}>
                Entrar
              </FormButton>
            )}
          </HStack>
        </HStack>
      </Animated.View>
    </HStack>
  );
};

export default AnimatedHeader;
